import React, { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { download } from "../../lib/standardsApi";
import { Pill, btn, num } from "../pipeline/Layer";
import { cn } from "../../lib/utils";

export const LEVEL = { required: ["Required", "critical"], recommended: ["Recommended", "warning"], optional: ["Optional", "neutral"] };
export const LevelPill = ({ level, testid }) => <Pill tone={LEVEL[level][1]} testid={testid}>{LEVEL[level][0]}</Pill>;

// "In Silver · 12,500 rows · 180 days" or "Missing", from live Silver data; needed history with no readable dates is never shown as met.
export function SilverBadge({ s, need, testid }) {
  if (!s?.in_silver) return <Pill tone="critical" testid={testid}>Missing</Pill>;
  const unknown = need && s.days == null;
  const short = need && s.days != null && s.days < need;
  const label = unknown ? "In Silver · history unknown" : short ? "In Silver · short history" : s.stage === "gold" ? "In Gold" : "In Silver";
  const span = s.days == null ? (unknown ? " · no readable dates" : "")
    : s.snapshots ? ` · ${num(s.snapshots)} snapshot${s.snapshots === 1 ? "" : "s"} over ${num(s.days)} days` : ` · ${num(s.days)} days`;
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5" data-testid={testid}>
      <Pill tone={unknown || short ? "warning" : "success"}>{label}</Pill>
      <span className="text-[11px] text-muted font-mono-tabular">{num(s.rows)} rows{span}</span>
    </span>
  );
}

export function DownloadButton({ file, label, testid, primary }) {
  const [state, setState] = useState({ busy: false, error: null });
  const go = async () => {
    setState({ busy: true, error: null });
    try { await download(file); setState({ busy: false, error: null }); } catch (e) { setState({ busy: false, error: e.message }); }
  };
  return (
    <span className="inline-flex flex-col">
      <button data-testid={testid} onClick={go} disabled={state.busy}
        className={cn(btn, "h-8 px-3 text-[12px]", primary ? "bg-primary text-primary-fg hover:opacity-90" : "border border-border hover:border-primary hover:text-primary")}>
        {state.busy ? <Loader2 size={12} className="animate-spin" /> : <Download size={12} />}{label}</button>
      {state.error && <span className="text-[11px] text-critical mt-1" data-testid={`${testid}-error`}>{state.error}</span>}
    </span>
  );
}

export const Section = ({ title, children, testid, aside }) => (
  <section className="space-y-2.5" data-testid={testid}>
    <div className="flex items-baseline gap-2 border-b border-border pb-1.5"><h3 className="kpi-label flex-1">{title}</h3>{aside}</div>
    {children}
  </section>
);
